import { useContext } from 'react';

import { AssetsFiltersContext } from '../providers/assets-filters';

export { defaultAssetsFilters } from '../providers/assets-filters';

export function useAssetsFilters() {
  return useContext(AssetsFiltersContext);
}
